import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';
import { Plus } from 'lucide-react';

function EventBanner() {
    let dark = useSelector((state) => { return state.Darkmode.value });

    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    const [data, setData] = useState([])
    const [dataList, setDataList] = useState([])

    const [createModal, setCreateModal] = useState(false)
    const [updateModal, setUpdateModal] = useState(false)
    const [clickId, setClickId] = useState([])

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        ListData()
        UpgradeData()
    }, [reload])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/wallet-event', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setData(tmp?.data?.banners ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    // wallet-network 조회
    const ListData = async () => {
        setSpinner(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/wallet-network');
            let tmp = response.data;
            if (tmp?.code == 1000) {
                console.log(tmp);
                setDataList(tmp?.data?.network ?? []);
            }
            setSpinner(false);
        } catch (error) {
            console.log(error);
            setSpinner(false);
        }
    };

    // (4) select 박스 선택된 currency
    const [selectedCurrency, setSelectedCurrency] = useState("all");

    // select 변경 핸들러
    const handleSelectChange = (e) => {
        setSelectedCurrency(e.target.value);
    };

    // (5) 데이터 필터링
    const filteredData = selectedCurrency === "all"
        ? data
        : data.filter((item) => item.we_network.toLowerCase() === selectedCurrency || item.we_network.toLowerCase() === "all");

    return (
        <div className='main'>
            <Message message={message} />
            {createModal && (<CreateModal darkname={darkname} setModal={setCreateModal} setReload={setReload} dataList={dataList} />)}
            {updateModal && (<UpdateModal darkname={darkname} setModal={setUpdateModal} clickId={clickId} setReload={setReload} dataList={dataList} />)}
            <div className={`main-box ${darkname}`}>
                <div className="member-1">
                    <div className="modal-btn" onClick={() => setCreateModal(true)}>
                        등록
                    </div>
                </div>

                <div className='password-1' style={{ width: "200px", marginTop: "20px", padding: "0", paddingRight: "5px" }}>
                    {/* (6) select 박스: '전체' + dataList 의 symbol */}
                    <select value={selectedCurrency} onChange={handleSelectChange}
                        style={{ width: "100%", border: "none", outline: "none", padding: "7px 10px", borderRadius: "5px" }}>
                        <option value="all">전체</option>
                        {dataList.map((a, i) => (
                            <option key={i} value={a.symbol}>
                                {a.symbol}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={`member-2 ${darkname}`} style={{ width: "100%" }}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "5%", minWidth: "70px" }}>no.</div>
                        <div style={{ width: "8%", minWidth: "100px" }}>네트워크</div>
                        <div style={{ width: "8%", minWidth: "100px" }}>상태</div>
                        <div style={{ width: "12%", minWidth: "200px" }}>영어 배너</div>
                        <div style={{ width: "8%", minWidth: "150px" }}>영어 제목</div>
                        <div style={{ width: "10%", minWidth: "200px" }}>영어 내용</div>
                        <div style={{ width: "15%", minWidth: "400px" }}>URL</div>
                        <div style={{ width: "12%", minWidth: "150px" }}>비고</div>
                    </div>
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ?
                                <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                :
                                filteredData.length === 0
                                    ?
                                    <div className="data-nofound">
                                        <img src="/img/img_nofound.png" alt="nofound-light" />
                                        <img
                                            src="/img/img_nofound_dark.svg"
                                            style={{ display: "none" }}
                                            alt="nofound-dark"
                                        />
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    :
                                    <>
                                        {filteredData.map((a, i) => (
                                            <MemberItem
                                                key={i}
                                                item={a}
                                                darkname={darkname}
                                                dark={dark}
                                                setUpdateModal={setUpdateModal}
                                                setClickId={setClickId}
                                                setReload={setReload}
                                            />
                                        ))}
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, dark, setUpdateModal, setClickId, setReload }) {
    const rowRef = useRef(null); // Ref 생성
    const [rowHeight, setRowHeight] = useState(0); // 높이 상태 관리
    const [cnt, setCnt] = useState(false)

    useEffect(() => {
        if (rowRef.current) {
            setRowHeight(rowRef.current.offsetHeight); // 높이 측정
            setCnt(true)
        }
    }, [cnt]); // 첫 렌더링 이후 실행

    const onClickData = () => {
        setClickId(item);
        setUpdateModal(true)
    }

    const onSubmitDelete = async () => {
        if (window.confirm(`${item.no}번을 삭제하겠습니까?`)) {
            await axios.post(process.env.REACT_APP_API + "/api/wallet-event/delete", {
                id: item.no
            }, {
                // headers: { 'Content-Type': 'multipart/form-data' },
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setReload(e => !e)
                }
                else {
                    // setMessage({ msg: "등록에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    return (
        <>
            <div ref={rowRef} className={`table-body-tr ${darkname}`} style={{ height: rowHeight ? `${rowHeight}px` : 'auto', minHeight: "40px" }}>
                <div className='td' style={{ width: "5%", minWidth: "70px" }}>{item.no}</div>
                <div className='td' style={{ width: "8%", minWidth: "100px" }}>{item.we_network}</div>
                <div className='td' style={{ width: "8%", minWidth: "100px" }}>
                    {item.we_is_active === 1 ? "활성" : "비활성"}
                </div>
                <div className='td' style={{ width: "12%", minWidth: "200px" }}>
                    {item.we_banner_image_en_url && (
                        <img
                            src={item.we_banner_image_en_url}
                            alt="English Banner"
                            style={{ width: "100%", maxHeight: "100px", objectFit: "contain" }}
                        />
                    )}
                </div>
                <div className='td' style={{ width: "8%", minWidth: "150px" }}>{item.we_title_en}</div>
                <div className='td' style={{ width: "10%", minWidth: "200px" }}>{item.we_contents_en}</div>
                <div className='td' style={{ width: "15%", minWidth: "400px", cursor: "pointer" }} onClick={() => window.open(item.we_ext_url)}>
                    <div className='table-overflow-hidden'>{item.we_ext_url}</div>
                </div>
                <div className='td' style={{ width: "12%", minWidth: "150px", display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                    <div className="upgrade-btn" onClick={() => onClickData()} style={{ backgroundColor: "#003577", color: "#fff" }}>수정</div>
                    <div className="upgrade-btn" onClick={() => onSubmitDelete()}>삭제</div>
                </div>
            </div>
        </>
    )
}

function CreateModal({ darkname, setModal, setReload, dataList }) {
    const [formData, setFormData] = useState({
        titleEn: "",
        contentsEn: "",
        bannerImageEnUrl: "",
        extUrl: "",
        active: "1", // 기본값 설정
        networkGroup: "all",
    });

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value, // name 속성에 따라 동적으로 업데이트
        }));
    };

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/wallet-event", {
            we_title_en: formData.titleEn,
            we_contents_en: formData.contentsEn,
            we_banner_image_en_url: formData.bannerImageEnUrl,
            we_ext_url: formData.extUrl,
            we_is_active: formData.active,
            we_network: formData.networkGroup
        }).then((response) => {
            const tmp = response.data;
            if (tmp?.code === 1000) {
                setModal(false);
                setReload((e) => !e);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        if (name === "tokenType") {
            // coin -> tokenAddress = ""
            setFormData((prev) => ({
                ...prev,
                tokenType: value,
                tokenAddress: value === "coin" ? "" : prev.tokenAddress,
            }));
        } else if (name === "networkGroup") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "500px" }}>
                    <div className="modal-1-header">이벤트배너 등록</div>

                    <div style={{ marginBottom: "30px" }}>
                        {/* 네트워크 이름 (select) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 이름
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ padding: "0", paddingRight: "5px" }}
                            >
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="all">전체</option>
                                    {dataList.map((a, i) => (
                                        <option key={i} value={a.symbol}>
                                            {a.symbol}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">영어 제목</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="titleEn"
                                    value={formData.titleEn}
                                    onChange={onChangeInput}
                                    placeholder="Title in English"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">영어 본문</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="contentsEn"
                                    value={formData.contentsEn}
                                    onChange={onChangeInput}
                                    placeholder="Contents in English"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">배너이미지 영어 URL</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="bannerImageEnUrl"
                                    value={formData.bannerImageEnUrl}
                                    onChange={onChangeInput}
                                    placeholder="Banner image English URL"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">이동될 URL</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="extUrl"
                                    value={formData.extUrl}
                                    onChange={onChangeInput}
                                    placeholder="External URL"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">상태</div>
                            <div className={`password-1 ${darkname}`}>
                                <select
                                    name="active"
                                    value={formData.active}
                                    onChange={onChangeInput}
                                    style={{
                                        width: "100%",
                                        height: "20px",
                                        border: "none",
                                        outline: "none",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="1">활성</option>
                                    <option value="0">비활성</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            등록
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setModal(false)}>
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function UpdateModal({ darkname, setModal, clickId, setReload, dataList }) {
    const [formData, setFormData] = useState({
        titleEn: clickId.we_title_en,
        contentsEn: clickId.we_contents_en,
        bannerImageEnUrl: clickId.we_banner_image_en_url,
        extUrl: clickId.we_ext_url,
        active: clickId.we_is_active, // 기본값 설정
        networkGroup: clickId.we_network
    });

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value, // name 속성에 따라 동적으로 업데이트
        }));
    };

    const onSubmit = async () => {
        await axios.post(process.env.REACT_APP_API + "/api/wallet-event/update", {
            id: clickId.no,
            we_title_en: formData.titleEn,
            we_contents_en: formData.contentsEn,
            we_banner_image_en_url: formData.bannerImageEnUrl,
            we_ext_url: formData.extUrl,
            we_is_active: formData.active,
            we_network: formData.networkGroup
        }).then((response) => {
            const tmp = response.data;
            if (tmp?.code === 1000) {
                setModal(false);
                setReload((e) => !e);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const onChangeSelect = (e) => {
        const { name, value } = e.target;
        if (name === "tokenType") {
            // coin -> tokenAddress = ""
            setFormData((prev) => ({
                ...prev,
                tokenType: value,
                tokenAddress: value === "coin" ? "" : prev.tokenAddress,
            }));
        } else if (name === "networkGroup") {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    return (
        <div className="modal">
            <div className="modal-box">
                <div className="modal-1" style={{ width: "500px" }}>
                    <div className="modal-1-header">이벤트배너 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        {/* 네트워크 이름 (select) */}
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">
                                네트워크 이름
                            </div>
                            <div
                                className={`password-1 ${darkname}`}
                                style={{ padding: "0", paddingRight: "5px" }}
                            >
                                <select
                                    name="networkGroup"
                                    value={formData.networkGroup}
                                    onChange={onChangeSelect}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        outline: "none",
                                        padding: "7px 10px",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="all">전체</option>
                                    {dataList.map((a, i) => (
                                        <option key={i} value={a.symbol}>
                                            {a.symbol}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">영어 제목</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="titleEn"
                                    value={formData.titleEn}
                                    onChange={onChangeInput}
                                    placeholder="Title in English"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">영어 본문</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="contentsEn"
                                    value={formData.contentsEn}
                                    onChange={onChangeInput}
                                    placeholder="Contents in English"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">배너이미지 영어 URL</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="bannerImageEnUrl"
                                    value={formData.bannerImageEnUrl}
                                    onChange={onChangeInput}
                                    placeholder="Banner image English URL"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">이동될 URL</div>
                            <div className={`password-1 ${darkname}`}>
                                <input
                                    name="extUrl"
                                    value={formData.extUrl}
                                    onChange={onChangeInput}
                                    placeholder="External URL"
                                />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className="password">상태</div>
                            <div className={`password-1 ${darkname}`}>
                                <select
                                    name="active"
                                    value={formData.active}
                                    onChange={onChangeInput}
                                    style={{
                                        width: "100%",
                                        height: "20px",
                                        border: "none",
                                        outline: "none",
                                        borderRadius: "5px",
                                    }}
                                >
                                    <option value="1">활성</option>
                                    <option value="0">비활성</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="modal-btn-box">
                        <div className={`modal-btn ${darkname}`} onClick={onSubmit}>
                            수정
                        </div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setModal(false)}>
                            취소
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EventBanner;